// Projects.jsx
import React from "react";
import "../Projects/Project.css"; // CSS file

// Corrected import paths (relative to src/)
import malawiImage from "../../src/Assets/Images/Projects/Malawi.png";
import somaliaImage from "../../src/Assets/Images/Projects/somalia.jpg";
import greenClimateImage from "../../src/Assets/Images/Projects/climate.webp";
import mekongImage from "../../src/Assets/Images/Projects/giz.jpg";
import flozImage from "../../src/Assets/Images/Projects/flozz.jpg";
import pakistanImage from "../../src/Assets/Images/Projects/Dutch.png";
import wrap from "../../src/Assets/Images/Projects/wra.png";
import infarmer from "../../src/Assets/Images/Projects/infarmer.png";
import adb from "../../src/Assets/Images/Projects/ADB.jpeg";
import fao from "../../src/Assets/Images/Projects/FAO.jpeg";

// Create projectImages array with imported images
const projectImages = [
  malawiImage, // Malawi.png
  somaliaImage, // WorldBank.png
  greenClimateImage, // Consultancy.jpg
  mekongImage, // GCF.png
  flozImage, // floz.jpg
  pakistanImage, // Dutch.png
  wrap,
  infarmer,
  adb,
  fao
];

const projects = [
  //  {
  //   id: 1,
  //   title: "inFarmer",
  //   description: "inFarmer. inFarmer.io developed in 2020 provides climate-smart precision agriculture solutions to help reduce the input cost and GHG emissions. Our solution offers a unique value proposition in the agricultural and forest sectors by combining cutting-edge satellite technology with advanced algorithms. This allows us to provide farmers with precise and actionable insights to optimise their production while minimising their carbon footprint. The approach inFarmer has taken to ensure sustainability by creating a clear incentive and business case for commercial enterprises to opt, use and pay for this service. They are provided with information that can improve marketing and logistical operations and monitor challenges to the social responsibility of their products. Examples include better targeted marketing of agricultural inputs; reliable identification and quantification of crops, sustainable production with low GHG emissions, GHG emission monitoring and reduction leading towards net zero, etc. It is a cloud-enabled data-driven DSS which uses hydrological, water-crop-soil, and forecasting models based on Machine Learning (ML) and Artificial Intelligence (AI) techniques. inFarmer mitigates the climate risks of farmers and lend risks of banks and financial institutes through an index-based parametric insurance. Our cloud-enabled, data-driven Decision Support System (DSS) integrates hydrological, water-crop-soil, and forecasting models powered by Machine Learning (ML) and Artificial Intelligence (AI). In addition, inFarmer offers parametric crop insurance, which protects farmers against climate-related risks by providing fast, transparent, and index-based payouts in the event of extreme weather or crop loss. This not only mitigates climate risks for farmers but also reduces lending risks for banks and financial institutions.",
  //   category: ["Technology"],
  //   funding: "Multiple",
  //   location: "Global",
  //   image: projectImages[7],
  //   stats: ["Parametric crop insurance", "GHG calculations"]
  // },
  {
    id: 2,
    title: "LTA for Project prepration Facility.",
    description:
      "This Long Term Agreement (LTA) for Provision of Consultancy Services for Project Preparation Facility by Green Climate Fund is designed to provide continuous, on-demand technical expertise and advisory support for the preparation and development of projects across multiple sectors. Under this agreement, specialized consultancy services are mobilized to conduct feasibility studies, baseline assessments, technical designs, economic and financial analyses, safeguard assessments, and other preparatory tasks that are essential for transforming project concepts into bankable and implementation-ready proposals. The LTA framework ensures efficiency, cost-effectiveness, and timely delivery by streamlining the contracting process, allowing clients to quickly access qualified experts as and when required. This arrangement strengthens institutional capacity, accelerates project implementation, and enhances the quality and impact of development investments.",
    category: ["Climate Change"],
    funding: "Green Climate Fund",
    location: "Global",
    image: projectImages[2],
    stats: ["Project Preparation", "Technical Advisory"],
  },
  {
    id: 3,
    title: "Water Resource Accountability in Pakistan (WRAP)",
    description:
      "This FCDO funded program is designed to strengthen the management, governance, and sustainability of the country’s water resources. It aims to improve the availability, quality, and transparency of water data while enhancing institutional capacity for integrated water resources management. The program promotes evidence-based decision-making through modern tools such as satellite monitoring, digital platforms, and field-based assessments, ensuring that water use is efficient, equitable, and environmentally sustainable.",
    category: ["Water Resources"],
    funding: "FCDO",
    location: "Pakistan",
    image: projectImages[6],
    stats: ["Water resource management", "Capacity building"],
  },
  {
    id: 4,
    title:
      "Transboundary Ecosystem-based Flood and Drought Management for Climate",
    description:
      "This GIZ funded project aims to strengthen climate resilience in one of the most climate-vulnerable regions of the world. The Lower Mekong Basin is highly exposed to extreme floods and prolonged droughts, which threaten agriculture, fisheries, ecosystems, and livelihoods across multiple countries. This project adopts an ecosystem-based approach, integrating natural infrastructure such as wetlands, forests, and riverine ecosystems with conventional flood and drought management practices. By promoting transboundary cooperation among riparian countries, it enhances data sharing, early warning systems, and joint planning for water resources. The approach not only reduces disaster risks but also safeguards biodiversity, sustains ecosystem services, and improves community resilience. Ultimately, the project provides a nature-based and cooperative framework to adapt to climate change impacts while ensuring sustainable development in the Mekong Basin.",
    category: ["Climate Change", "River Basin Managment"],
    funding: "GIZ",
    location: "Lower Mekong Basin",
    image: projectImages[3],
    stats: ["Ecosystem Management", "Transboundary Cooperation"],
  },
  {
    id: 5,
    title: "Floz - Cloud-based Water Management Platform",
    description:
      "floz is a cloud-based Software as a Service (SaaS) developed by WaterSprint in 2022 and is ongoing globally. It serves as an advanced decision support system for flood forecasting, hydro-climatic modelling, and early warning dissemination. Integrating multiple models such as WFLOW, SFINCS, MODFLOW 6, SEAWAT, 3Di, HEC-HMS, and HEC-RAS, floz enables real-time simulations under current and future climate scenarios. The platform automatically processes weather and climate data, runs models in the cloud, and visualizes results for effective water and disaster risk management. Through an interactive dashboard and centralized data warehouse, users can analyze water systems, evaluate management measures, and access essential geospatial and timeseries data.",
    category: ["Technology"],
    funding: "WaterSprint",
    location: "Global",
    image: projectImages[4],
    stats: ["Cloud Platform", "Real-time Forecasting"],
  },
  {
    id: 6,
    title:
      "I-DIP: Monitoring, Forecasting and Tackling Flash Droughts in Pakistan",
    description:
      "The I-DIP initiative is a collaboration between WaterSprint and FutureWater B.V. funded by the Dutch Government aims to develop an integrated monitoring and forecasting system for flash droughts — those quickly intensifying dry spells driven by high temperatures and low rainfall — in the southern Punjab region, especially around Bahawalpur and Bahawalnagar. Using climate data (precipitation trends, temperature anomalies), soil moisture indices, remote sensing and historical drought records, the project seeks to identify early warning signals of flash drought onset. It will combine forecasting tools and field-based validation to predict where and when drought conditions are likely to escalate rapidly, so local authorities, farmers, and water managers can act in advance. By building local capacity for decision-making and implementing adaptive water management and agricultural practices, the goal is to reduce crop losses, protect livelihoods, and improve resilience to climate‐driven impacts in water‐stressed zones of Bahawalpur and Bahawalnagar.",
    category: ["Drought Management", "Technology"],
    funding: "Dutch Government",
    location: "Pakistan",
    image: projectImages[5],
    stats: ["Drought Monitoring", "Early Warning System"],
  },
  {
    id: 7,
    title:
      "Provision of Mapping Groundwater Potential using Geo-spatial Technologies in Malawi",
    description:
      "The project funded by the UNICEF focuses on the application of advanced spatial analysis tools to identify and map areas with high groundwater availability. By integrating remote sensing, GIS, and hydrogeological data, the project develops groundwater potential maps that classify zones into high, medium, and low potential. These maps serve as decision-support tools for policymakers, planners, and water managers, helping to reduce the cost and risk of drilling unsuccessful boreholes, while supporting sustainable water supply and agricultural development. Ultimately, the project contributes to improving water security and resilience to climate variability and drought conditions in Malawi.",
    category: ["Water Resources"],
    funding: "UNICEF",
    location: "Malawi",
    image: projectImages[0],
    stats: ["Groundwater Mapping", "Sustainable Development"],
  },
  {
    id: 8,
    title: "Establishment of data integration system for Somalia Govt.",
    description:
      "The project funded by the World Bank aimed to strengthen the country's capacity to manage and utilize data for evidence-based decision-making in water resources and related sectors. Through this initiative, a centralized and interoperable data management system is developed to integrate information from multiple ministries, agencies, and development partners. The system ensures standardized data collection, secure storage, and easy sharing across stakeholders, while promoting transparency and accountability. By building this digital infrastructure, the project supports the government in improving coordination, enhancing policy development, and enabling more efficient management of natural resources and public services.",
    category: ["Data Management", "Technology"],
    funding: "World Bank",
    location: "Somalia",
    image: projectImages[1],
    stats: ["Data Integration", "Digital Infrastructure"],
  },
  {
    id: 9,
    title: "ADB Climate Risk and Urban Water Resilience Assessment in Sindh",
    description:
   "This project supported the Asian Development Bank (ADB) in assessing climate and disaster risks for major secondary cities in Sindh Province, Pakistan, including Hyderabad, Larkana, Mirpur Khas, Nawabshah, and Sukkur. The study analyzed multi-hazard risks such as floods, extreme heat, and drought using climate projections, GIS data, and urban infrastructure assessments. The project evaluated the vulnerability of critical systems including water supply, drainage, transport, and community infrastructure. Based on these analyses, the project identified priority adaptation and resilience measures to guide future urban investments, strengthen climate resilience, and support sustainable urban development planning.",    category: ["Water Resources", "Climate Change"],
    funding: "Asian Development Bank (ADB)",
    location: "Pakistan",
    image: projectImages[8],
   stats: [
  "Climate Risk Assessment",
  "Urban Water Planning"
]
  },
  {
    id: 10,
    title: "Enhancing Water Harvesting in Balochistan",
    description:
      "The project focuses on a participatory assessment and enhancement of existing and potential water harvesting techniques in Balochistan, including spate irrigation, karez rehabilitation, and floodwater harvesting. It aims to improve water management and resilience in arid regions through community-driven approaches and sustainable practices.",
    category: ["Water Resources", "Climate Change"],
    funding: "UN-FAO, EU",
    location: "Pakristan",
    image: projectImages[9],
    stats: ["Spate Irrigation", "Karez Rehabilitation"]
  },
];

const Projects = () => {
  // Filter function for categories
  const filterProjects = (category) => {
    if (category === "All") return projects;
    return projects.filter(
      (project) =>
        Array.isArray(project.category) && project.category.includes(category),
    );
  };

  // Available categories
  const categories = [
    "All",
    "Water Resources",
    "River Basin Managment",
    "Climate Change",
    "Technology",
    "Drought Management",
  ];

  const [activeCategory, setActiveCategory] = React.useState("All");
  const [filteredProjects, setFilteredProjects] = React.useState(projects);
  const [expandedProjects, setExpandedProjects] = React.useState({});

  React.useEffect(() => {
    setFilteredProjects(filterProjects(activeCategory));
    // Reset expanded projects when category changes
    setExpandedProjects({});
  }, [activeCategory]);

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
  };

  const toggleReadMore = (projectId) => {
    setExpandedProjects((prev) => ({
      ...prev,
      [projectId]: !prev[projectId],
    }));
  };

  return (
    <div className="projects-page">
      {/* Header Section */}
      <header className="projects-header">
        <div className="container">
          <h1 className="projects-title">Our Projects</h1>
          <p className="projects-subtitle">
            Transforming water management through innovative solutions and
            sustainable practices
          </p>
        </div>
      </header>

      {/* Category Filter */}
      <section className="projects-filter">
        <div className="container">
          <div className="filter-tabs">
            {categories.map((category) => (
              <button
                key={category}
                className={`filter-tab ${activeCategory === category ? "active" : ""}`}
                onClick={() => handleCategoryClick(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="projects-grid-section">
        <div className="container">
          {filteredProjects.length > 0 ? (
            <div className="projects-grid">
              {filteredProjects.map((project) => {
                const isExpanded = expandedProjects[project.id];
                const shortDescription = project.description.substring(0, 150);
                const shortTitle =
                  project.title.length > 60
                    ? project.title.substring(0, 60) + "..."
                    : project.title;

                return (
                  <div key={project.id} className="project-card">
                    {/* Image Section */}
                    <div className="project-image-container">
                      <img
                        src={project.image}
                        alt={project.title}
                        className="project-image"
                        onError={(e) => {
                          // Fallback to a default image if the specific project image fails
                          e.target.src = malawiImage; // Use imported image directly
                        }}
                      />
                      <div className="project-category-badge">
                        {Array.isArray(project.category)
                          ? project.category.join(", ")
                          : project.category}
                      </div>
                    </div>

                    {/* Content Section */}
                    <div className="project-content">
                      <div className="project-meta">
                        <span className="project-location">
                          {project.location}
                        </span>
                        <span className="project-funding">
                          • {project.funding}
                        </span>
                      </div>

                      <h3 className="project-title">
                        {isExpanded ? project.title : shortTitle}
                      </h3>

                      <div
                        className={`project-description ${isExpanded ? "expanded" : ""}`}
                      >
                        <p>
                          {isExpanded
                            ? project.description
                            : `${shortDescription}...`}
                        </p>
                      </div>

                      <div className="project-footer">
                        <button
                          className="read-more-btn"
                          onClick={() => toggleReadMore(project.id)}
                        >
                          {isExpanded ? "Show Less" : "Read More"}
                        </button>
                        <div className="project-stats">
                          {Array.isArray(project.stats)
                            ? project.stats.map((stat, index) => (
                                <span key={index} className="stat-item">
                                  {stat}
                                </span>
                              ))
                            : null}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="no-projects">
              <h3>No projects found in this category</h3>
              <p>Try selecting a different category to explore our work</p>
            </div>
          )}

          {/* Stats Section */}
          <div className="projects-stats">
            <div className="stat-card">
              <h4>6+</h4>
              <p>Active Projects</p>
            </div>
            <div className="stat-card">
              <h4>5</h4>
              <p>Countries</p>
            </div>
            <div className="stat-card">
              <h4>Global</h4>
              <p>Impact</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects;
